import React from 'react';
import Seo from './common/Seo';
import './home/home.css';

import Drawer from './common/Drawer';
import Figures from './home/Figures';
import HeroHeader from './home/HeroHeader';
import Projects from './home/Projects';
import Services from './home/Services';
import Skills from './home/Skills';
import Team from './home/Team';
import Testimony from './home/Testimony';
import { useI18n } from './i18n/I18nContext';

function Home({route}) {
  const { t } = useI18n();
  const title = t("pages.home.title");
  const description = t("pages.home.description");

  return (
    <>
      <Seo title={title} description={description} />
      <div className="home-page">
        <HeroHeader />
        <Services />
        <Testimony />
        <Skills decoration={true} />
        <Team />
        <Figures />
        <Projects />
      </div>
      <Drawer route={route} />
    </>
  );
}

export default Home;
